export default __webpack_public_path__ + "static/media/custom_tshirt_preview_old.b219769c.png";